export function IconMoney({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      focusable="false"
      aria-hidden="true"
    >
      {/* Geldsack-Body: U-Kurve unten, schließt oben am Buendel */}
      <path d="M6 11 C5 14 5 18 7.5 20 C9 21 15 21 16.5 20 C19 18 19 14 18 11 Z" />
      {/* Buendel-Schnuerung oben */}
      <path d="M8 10 H16" />
      <path d="M9 8 H15" />
      {/* Zipfel oben (zugezogener Sackhals) */}
      <path d="M9 8 L10.5 5.5 L12 7 L13.5 5.5 L15 8" />
      {/* Euro-Andeutung: zwei horizontale Striche + C-Bogen */}
      <path d="M10.5 14.5 H13.5" />
      <path d="M10.5 16 H13" />
      <path d="M14 13.5 A2 2.5 0 1 0 14 17.5" />
    </svg>
  );
}
